import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/botoks-yapan-doktorlar-hangi-brans-yetkilidir-kimler-uygulama-yapabilir/page.tsx");
